import $ from 'jquery';

class HeaderScroll  {

	constructor(args) {

		this.vw = $(window).width();
		this.isOpen = false;
		this.headerThreshold = args.threshold;
		this.header = args.header;
		this.class = args.class;

		if (!$('body').hasClass('page-template-template-timeline')){
			this.handleHeaderClassChange();
			this.init();
			this.detectScroll();
		}


	}

	init() {

		if (this.vw >= 768) {
			this.handleScroll();
			this.doScroll();
		}
		else {
			this.header.addClass('open');
		}

	}

	doScroll() {

		$(window).on('scroll', () => {
			this.handleScroll();
		});

	}

		detectScroll() {
		var lastScrollTop = $(window).scrollTop();
		var self = this;

		if( lastScrollTop > 50 ){
			$('.header--mobile').addClass('scrolled');	
		}

		$(window).scroll(function(event){
			var scrollToTop = $(this).scrollTop();
			if( scrollToTop > 50 && !self.getIsScrolling) {

				if (scrollToTop > lastScrollTop){
					$('.header--mobile').addClass('scrolled');

					lastScrollTop = scrollToTop;
				} else if (scrollToTop < lastScrollTop){
					$('.header--mobile').removeClass('scrolled');

					lastScrollTop = scrollToTop;
				}
			}
		});

	}

	handleHeaderClassChange() {

		// this.scrollTop = $(window).scrollTop();
		var scrollTop = $(window).scrollTop();
		var isOpen = false;
		if( scrollTop > 500 && $('timeline__slider').length == 0 ) {
			if( !isOpen ) {
				isOpen = true;
				this.header.addClass( 'header--collapsed' );
			}
		}
		else {
			if( isOpen ) {
				isOpen = false;
				this.header.removeClass( 'header--collapsed' );
			}
		}

	}

	handleScroll() {

		this.scrollTop = $(window).scrollTop();

		if( this.scrollTop > this.headerThreshold  ) {
			if( !this.isOpen ) {
				this.isOpen = true;
				this.header.addClass( this.class );
			}
		}
		else {
			if( this.isOpen ) {
				this.isOpen = false;
				this.header.removeClass( this.class );
			}
		}

	}

}



module.exports = HeaderScroll;